import React from 'react';

const LOGO_SRC = `${process.env.PUBLIC_URL || ''}/brand/logo-oh-belleza.png`;

export default function BrandLogo({ size = 'md', light = false }) {
  const cls = `brand-logo brand-logo-${size}${light ? ' brand-logo-light' : ''}`;
  return (
    <div className={cls} aria-label="¡Oh! Belleza">
      <img src={LOGO_SRC} alt="¡Oh! Belleza" className="brand-logo-img" />
    </div>
  );
}
